import type { Bonus } from "../types";

export const getBounsArray = (
  bonus: Record<Bonus, string>,
): { key: Bonus; value: string }[] => {
  return Object.entries(bonus).map(
    ([key, value]): { key: Bonus; value: string } => {
      return {
        key: key as Bonus,
        value,
      };
    },
  );
};

export const parseRenewableFromSearchParams = (
  renewable: string | undefined,
) => {
  if (renewable === undefined) {
    return null;
  }
  return renewable === "true" ? true : renewable === "false" ? false : null;
};

export const parseRenewableToString = (renewable: boolean | null) => {
  return renewable === true ? "true" : renewable === false ? "false" : "all";
};
